const FONT_FAMILY = 'FONT_FAMILY';
const SUB_FONT_COLOR = 'SUB_FONT_COLOR';
const UNSUB_FONT_COLOR = 'UNSUB_FONT_COLOR';
const HEADLINE_COLOR = 'HEADLINE_COLOR';
const SUB_BGCOLOR = 'SUB_BGCOLOR';
const UNSUB_BGCOLOR = 'UNSUB_BGCOLOR';
const SET_DEFAULT = 'SET_DEFAULT';

const initState = {
  fontFamily: 'Open Sans',
  subBtnFontColor: '#fff',
  unSubBtnFontColor: '#fff',
  headlineColor: '#ff694b',
  subBtnBgColor: '#3276b1',
  unSubBtnBgColor: '#a90329'
};

export function page(state=initState, action) {
  switch (action.type) {
    case FONT_FAMILY:
      return {...state, fontFamily: action.payload};
    case SUB_FONT_COLOR:
      return {...state, subBtnFontColor: action.payload};
    case UNSUB_FONT_COLOR:
      return {...state, unSubBtnFontColor: action.payload};
    case HEADLINE_COLOR:
      return {...state, headlineColor: action.payload};
    case SUB_BGCOLOR:
      return {...state, subBtnBgColor: action.payload};
    case UNSUB_BGCOLOR:
      return {...state, unSubBtnBgColor: action.payload};
    case SET_DEFAULT:
      return initState;
    default:
      return state;
  }
}

export function setDefault() {
  return {type: SET_DEFAULT};
}

export function setFontFamily(data) {
  return {type: FONT_FAMILY, payload: data};
}

export function setSubBtnFontColor(data) {
  return {type: SUB_FONT_COLOR, payload: data};
}

export function setUnSubBtnFontColor(data) {
  return {type: UNSUB_FONT_COLOR, payload: data};
}

export function setHeadlineColor(data) {
  return {type: HEADLINE_COLOR, payload: data};
}

export function setSubBtnBgColor(data) {
  return {type: SUB_BGCOLOR, payload: data};
}

export function setUnsubBtnBgColor(data) {
  return {type: UNSUB_BGCOLOR, payload: data};
}



// WEBPACK FOOTER //
// ./src/redux/reducer/page.js